<coreui-modal #newDefinitionModal modalWidth="100" modalHeight="100" panelCssClass="definition-model">
  <ng-template #titleTemplate>
    <ng-container *ngTemplateOutlet="AudienceAITag"> </ng-container>
  </ng-template>
  <ng-template #titleCloseButtonTemplate>
    <button class="titleCloseButton" type="button" (click)="closeModal(newDefinitionModal)" coreUIButton="icon-large">
      <i coreUIIcon="close"></i>
    </button>
  </ng-template>
  <ng-template #contentTemplate>
    <form [formGroup]="audienceAIFormGroup">
      <div *ngIf="chatConversations.chat_history.length <= 2 && chatConversations.chat_history.length > 0">
        <lib-audience-ai-welcome [chatInput]="chatInput" [AssistantIcon]="AssistantIcon" [typingMessage]="typingMessage"
          [inputContext]="getInputContext()" [hasResponseError]="hasResponseError" [errorMessage]="errorMessage"
          [chatContent]="this.chatConversations?.chat_history[1]?.content['chat_message']">
        </lib-audience-ai-welcome>
      </div>
      <div *ngIf="isError" class="error-not-found">
        <coreui-error-state header="Uh-Oh" subheader="Something Went Wrong" illustration="somethingWentWrong">
          The page you requested was not found.
        </coreui-error-state>
      </div>
      <div class="container" *ngIf="chatConversations.chat_history.length > 2">
        <!-- Left Container -->
        <div class="left-section" [class.expanded]="previewCollapsed">
          <div class="chat-section">
            <div #chatMessages class="chat-messages" *ngIf="chatConversations.chat_history"
              (scroll)="onScroll(chatContainer)">
              <div *ngFor="let chat of chatConversations.chat_history; let i = index">
                <div *ngIf="i > 1 && dateGrouping(chat, i)" class="inline-container">
                  <span coreUIDivider class="divider-before"></span>
                  <span class="divider-text">{{chat.additional_kwargs?.created_at | date:'dd - MMM - y'}}</span>
                  <span coreUIDivider class="divider-after"></span>
                </div>
                <div *ngIf="chat.type === 'human' && i!==0" class="user-text text-style-3"
                  [innerHTML]="chat.content | markdownToHtml"></div>
                <div *ngIf="chat.type === 'ai'" class="assistant-chat">
                  <ng-container *ngTemplateOutlet="AssistantIcon"></ng-container>
                  <div *ngIf="displayErrorMessage(chat)">
                    <ng-container
                      *ngTemplateOutlet="errorMessage; context: { $implicit: chat.content['chat_message'] }"></ng-container>
                  </div>
                  <div class="chat-message-container" *ngIf="!displayErrorMessage(chat)">
                    <div class="assistant-text" *ngIf="!chat.content['chat_message'].includes('SEARCH_AGENT')">
                      <div [innerHTML]="chat.content['chat_message'] | markdownToHtml"></div>
                      <coreui-card [text]="sqlContent" class="sqlContent" *ngIf="chat.additional_kwargs?.sqlClause">
                        <ng-template #sqlContent>
                          <div>
                            <div class="sql-header">
                              <div class="sql-label">View Definition Criteria</div>
                              <button class="text-style-muted-3" type="button" coreUIButton="text-primary"
                                      withIcon="left" (click)="copyToClipboard()">
                                <i coreUIIcon="copy"></i> Copy to clipboard
                              </button>
                            </div>
                            <div class="sql-clause"
                                 [innerHTML]="addSQLTags(chat.additional_kwargs.sqlClause) | markdownToHtml"></div>
                          </div>
                        </ng-template>
                      </coreui-card>
                      <div
                        *ngIf="chat.additional_kwargs?.['sampleData']?.length > 0 && chat.additional_kwargs?.['preview_job_id']">
                        <div class="pane-header">
                          <h2> Matching Customer Profiles </h2>
                          <button class="expand-button" coreUIButton="text-primary"
                            (click)="showModal(expandPreviewModal, chat)" withIcon="left">
                            <i coreUIIcon="expandWindow"></i> Expand </button>
                        </div>
                        <div class="table-container">
                          <ng-container *ngTemplateOutlet="previewTable; context: { $implicit: chat }">
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <div class="assistant-text" *ngIf="chat.content['chat_message'].includes('SEARCH_AGENT')">
                      <p>Here are the attributes you’ve requested. Click the
                        <i class="searchIcon" coreUIIcon="search" scale="1.4"></i>
                        to view all attribute values
                      </p>
                      <lib-attribute-search [chat]="chat.content['response']" [contextId]="contextId"
                                            (pickListValues)="emitPickListValues($event)"></lib-attribute-search>
                    </div>
                    <div *ngIf="isFeedbackMenuShown(chat.additional_kwargs.genai_request_id)"
                      class="feedback-container">
                      <div class="feedback-overview">
                        <span class="text-style-muted-1">Was this accurate?</span>
                        <div class="feedback-icons">
                          <button [ngClass]="{ 'selected-feedback-icon': isFeedbackSelected(i, 1) }" type="button"
                            coreUIButton="icon-large" (click)="selectFeedback(1, i)"><i
                              coreUIIcon="thumbsUp"></i></button>
                          <button [ngClass]="{ 'selected-feedback-icon': isFeedbackSelected(i, -1) }" type="button"
                            coreUIButton="icon-large" (click)="selectFeedback(-1, i)"><i
                              coreUIIcon="thumbsDown"></i></button>
                        </div>
                      </div>
                      <coreui-card *ngIf="isCommentAreaShown(i)" class="comment-section">
                        <div class="comment-header">
                          <div>
                            <span class="text-style-2">Tell us more </span>
                            <span class="text-style-muted-4">(Optional)</span>
                          </div>
                          <button type="button" coreUIButton="icon-large" (click)="close(i)"><i
                              coreUIIcon="close"></i></button>
                        </div>
                        <coreui-form-field>
                          <textarea class="comment-text-area" coreUIInput formControlName="commentMessage"></textarea>
                          <div>
                            <button type="submit" coreUIButton="primary" (click)="submitFeedback(i)">Submit</button>
                          </div>
                        </coreui-form-field>
                      </coreui-card>
                      <coreui-notification [notificationStyle]="notificationStyle" [isPersistent]="true"
                        [autoShow]="true" *ngIf="chat.additional_kwargs?.feedback?.showNotification"> {{
                        notificationMessage }} </coreui-notification>
                    </div>
                    <div class="assistant-options" *ngIf="chatConversations.chat_history.length === i+1">
                      <button class="option-buttons" *ngFor="let option of chat.content['options']" type="button"
                        coreUIButton="micro-secondary" (click)="selectOption(option)">{{option}}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="isQueryRunning && chatConversations.chat_history.length > 2">
                <div class="assistant-chat">
                  <ng-container *ngTemplateOutlet="AssistantIcon"></ng-container>
                  <ng-container *ngTemplateOutlet="typingMessage"></ng-container>
                  <div class="showCancel" *ngIf="showCancel">
                    <button type="button" coreUIButton="micro-secondary" (click)="cancelJob()"> Cancel {{ jobType }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="scroll" *ngIf="!isScrollAtBottom">
              <button class="scroll-button" coreUIButton="icon" (click)="scrollToBottom(chatContainer)">
                <i scale="1.5" coreUIIcon="arrowDown"></i>
              </button>
            </div>
            <div class="chat-input">
              <ng-container *ngTemplateOutlet="chatInput; context: { $implicit: getInputContext() }"></ng-container>
              <div class="text-style-5 input-message">
                Audience AI is in a beta stage and can make mistakes. Currently, our system builds audiences using
                Profile, Sales,
                and TSP (Total Source Plus) data.
              </div>
            </div>
          </div>
        </div>
        <!-- Right Container -->
        <div class="right-section" [class.collapsed]="previewCollapsed">
          <lib-audience-ai-preview [previewData]="this.audienceAIFormGroup.get('previewData')?.value || {}"
            [count]="count" (previewContent)="previewContainer = $event"
            (previewCollapsed)="previewCollapsed = $event"></lib-audience-ai-preview>
        </div>
      </div>
    </form>
  </ng-template>
</coreui-modal>
<lib-confirmation-popup #restartConfirmationPopup [title]="confirmationTitle" [confirmationMessage]="customMessage"
  [confirmButtonText]="confirmText" [cancelButtonText]="cancelText" (confirmEvent)="handleRestartConfirm()"
  (cancelEvent)="handleCancel()">
</lib-confirmation-popup>
<div>
  <coreui-notification notificationStyle="error" #toastError>
    {{ errorMessage }}</coreui-notification>
</div>

<coreui-modal panelCssClass="preview-model" modalWidth="90" modalHeight="auto" [autoFocus]="false" #expandPreviewModal>
  <ng-template #titleTemplate>Matching Customer Profiles</ng-template>
  <ng-template #titleCloseButtonTemplate>
    <button type="button" (click)="expandPreviewModal.hide()" coreUIButton="icon-large">
      <i coreUIIcon="close"></i>
    </button>
  </ng-template>
  <ng-template #contentTemplate>
    <div class="expand-container">
      <ng-container *ngTemplateOutlet="previewTable; context: { $implicit: currentChat }">
      </ng-container>
    </div>
  </ng-template>
</coreui-modal>

<ng-template #previewTable let-chat>
  <coreui-table [fixedHeader]="true">
    <thead>
      <tr coreUITableHeaderRow>
        <th class="text-style-muted-1" *ngFor="let header of chat?.additional_kwargs?.['tableHeaders']">{{header}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of chat?.additional_kwargs?.['sampleData']" coreUITableRow>
        <td *ngFor="let header of chat?.additional_kwargs?.['tableHeaders']">{{row[header]}}</td>
      </tr>
    </tbody>
  </coreui-table>
</ng-template>

<ng-template #AudienceAITag>
  <div class="header-container">
    <h2 class="header-title">Audience AI</h2>
    <div class="beta-tag text-style-4">BETA</div>
  </div>
</ng-template>
<lib-confirmation-popup #backConfirmationPopup *ngIf="showSaveWarning" (confirmEvent)="handleBackConfirm()"
  (cancelEvent)="handleCancel()" [confirmButtonType]="'secondary'">
</lib-confirmation-popup>

<ng-template #AssistantIcon>
  <div class="assistant-icon-container">
    <div class="assistant-icon"><i scale="1.2" coreUIIcon="wand"></i></div>
  </div>
</ng-template>

<ng-template #typingMessage>
  <div class="typing-message">
    <span class="typing-message-circle"></span>
    <span class="typing-message-circle"></span>
    <span class="typing-message-circle"></span>
  </div>
</ng-template>

<ng-template #chatInput let-context>
  <form [formGroup]="audienceAIFormGroup">
    <div class="chat-input-wrapper">
      <div class="chat-input-content">
        <coreui-tag *ngIf="selectedPickList" [removable]="true"
                    (removed)="removePickListValue()">{{ selectedPickList }}
        </coreui-tag>
        <textarea #inputTextArea coreUIInput autofocus rows="1" class="chat-input-area"
                  [placeholder]="context.placeholderText" formControlName="chatInput"
                  (input)="onChatInputChange($event)" (keydown)="onKeyDown($event)"></textarea>
      </div>
      <button class="chat-input-button" *ngIf="!isQueryRunning" type="submit" coreUIButton="icon"
        [disabled]="isUserInputValid" (click)="submitQuery()">
        <i scale="1.5" coreUIIcon="arrowUp"></i>
      </button>
    </div>
  </form>
</ng-template>

<ng-template #errorMessage let-chat>
  <div class="assistant-text error-message-container">
    <i class="error-icon" coreUIIcon="errorShield" scale="1.5"></i>
    <div>
      <div class="text-style-3">{{chat}}</div>
    </div>
  </div>
  <button class="regenerate" type="button" coreUIButton="micro-secondary" withIcon="left" (click)="onRegenerate()"><i
    coreUIIcon="refresh"></i> Try Again
  </button>
</ng-template>
